import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LANGUAGE_CONFIG, LanguageConfigItem, Localizer, StorageKey } from '@delen/connect-core';

export const cultureResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot): void => {
  const localizer: Localizer = inject(Localizer);
  const languageConfig: LanguageConfigItem[] = inject(LANGUAGE_CONFIG);

  const supportedCultures = languageConfig.map((lan) => lan.language);
  const cultureFromQuery = route.queryParamMap.get('culture');

  if (cultureFromQuery && supportedCultures.includes(cultureFromQuery)) {
    localizer.setCulture(cultureFromQuery);
    localStorage.setItem(StorageKey.GlobalCulture, cultureFromQuery);
    return;
  } else if (localStorage.getItem(StorageKey.GlobalCulture)) {
    const culture: string = localStorage.getItem(StorageKey.GlobalCulture)!;
    if (culture && supportedCultures.includes(culture)) {
      localizer.setCulture(culture);
      return;
    }
  }

  // use default Localizer culture and save it
  const defaultCulture = supportedCultures[0];
  if (defaultCulture) {
    localStorage.setItem(StorageKey.GlobalCulture, defaultCulture);
  }
};
